import { createFileRoute } from '@tanstack/react-router'
import { ChatPage } from '@/features/chat/ui/chat-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/chat/')({
	component: ChatIndexRoute,
})

function ChatIndexRoute() {
	return (
		<PageLayout data-id='chat-page'>
			<ChatPage />
		</PageLayout>
	)
}
